<div class="root-container">
  <internal-sidebar
    #sidebar
    role="System Administrator"
    [links]="navLinks"
    class="sidebar"
    tabindex="0"/>

  <div class="main">
    <common-header (showSidebar)="showSidebar()"/>
      <div class="content scrollbars scrollbars">
        <div class="container">
          <router-outlet/>
        </div>
      </div>
    <common-footer/>
  </div>
  <modals #modals />
  <toast #toast />
</div>
